import React from 'react'
// import './css/Navbar.css';
import {NavLink, } from 'react-router-dom'

const Navbar = () => {
  return (
    <>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container">
  <a class="navbar-brand" href="/">
      <img src={require("../assets/images/vertoxLogo.png")} alt="" width="80" height="75"/>
    </a>
    <a class="navbar-brand" href="/">
    VERTOX LABS PVT. LTD.
    {/* <p className={"fs-6"}>(Scaling, Transforming)^x</p> */}
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item"> 
          <NavLink to="/" className={"nav-link"}>Home</NavLink>
        </li>
        {/* <li class="nav-item">
          <a class="nav-link" aria-current="page" href="/">Home</a>
        </li> */}
        <li class="nav-item">
          <NavLink to="/blog" className={"nav-link"}>Blog</NavLink>
        </li>
        <li class="nav-item">
          <NavLink to="/about" className={"nav-link"}>About</NavLink>
        </li>
        <li class="nav-item">
          <NavLink to="/contact" className={"nav-link"}>Contact</NavLink>
        </li>
        {/* <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="www.google.com" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            More
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item" href="/presskit">Press Kit</a></li>
            
            <li><a class="dropdown-item" href="/faq">FAQ</a></li>
            {/* <li><hr class="dropdown-divider" /></li>
            <li><a class="dropdown-item" href="#">Something else here</a></li> */}
          {/* </ul>
        </li>  */}
      </ul>
      {/* <Link to="/getintouch" class="btn btn-outline-dark" >Get In Touch</Link> */}
      {/* <form class="d-flex">
        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
        <button class="btn btn-outline-success" type="submit">Search</button>
      </form> */}
    </div>
  </div>
</nav>
    </>
  )
}

export default Navbar